export const ADD_IMAGE_TO_GALLERY_BUTTON_CONSTS = {
  addPhoto: '+ Добавить фото вручную',
  addPhotoTooltip: 'Загрузить новое фото в галерею',
  imagesCountLimitMessage: 'Превышен лимит по количеству фотографий в галерее'
}
